import React, { createContext, useContext, useState, useMemo } from "react";
import { translations } from "./i18n";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState("es");
  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: translations[lang],
      toggle: () => setLang((l) => (l === "es" ? "en" : "es")),
    }),
    [lang]
  );
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
};
